import { apiSlice } from "../../app/api/apiSlice";

export const planConfigApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlanConfig: builder.query({
      query: () => "/public/plan-config",
    }),
  }),
});

export const { useGetPlanConfigQuery } = planConfigApiSlice;
